import { Routes } from '@angular/router';
import { authGuard } from './core/auth/guards/auth.guard';
import { roleGuard } from './core/auth/guards/role.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layouts/public-layout/public-layout').then((m) => m.PublicLayout),
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/public-site/public-site.routes').then(
            (m) => m.PUBLIC_SITE_ROUTES,
          ),
      },
      {
        path: 'organizations',
        loadChildren: () =>
          import('./features/organizations/organizations.routes').then(
            (m) => m.ORGANIZATIONS_ROUTES,
          ),
      },
    ],
  },
  {
    path: 'auth',
    loadComponent: () => import('./layouts/auth-layout/auth-layout').then((m) => m.AuthLayout),
    children: [
      {
        path: '',
        loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
      },
    ],
  },
  {
    path: 'espace-jeune',
    canActivate: [authGuard, roleGuard(['jeune'])],
    loadComponent: () => import('./layouts/jeune-layout/jeune-layout').then((m) => m.JeuneLayout),
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/espace-jeune/espace-jeune.routes').then(
            (m) => m.ESPACE_JEUNE_ROUTES,
          ),
      },
    ],
  },
  {
    path: 'espace-partenaire',
    canActivate: [authGuard, roleGuard(['partenaire'])],
    loadComponent: () =>
      import('./layouts/partenaire-layout/partenaire-layout').then((m) => m.PartenaireLayout),
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/espace-partenaire/espace-partenaire.routes').then(
            (m) => m.ESPACE_PARTENAIRE_ROUTES,
          ),
      },
    ],
  },
  {
    path: 'manuel',
    loadChildren: () => import('./features/manual/manual.routes').then((m) => m.MANUAL_ROUTES),
  },
  {
    path: 'back-office-admin',
    canActivate: [authGuard, roleGuard(['admin'])],
    loadComponent: () =>
      import('./layouts/admin-layout/admin-layout').then((m) => m.AdminLayout),
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/back-office-admin/back-office-admin.routes').then(
            (m) => m.BACK_OFFICE_ADMIN_ROUTES,
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
